import React from "react";
import Checkbox from "@Components/Form/Checkbox";
import Arrow from "@Components/Icons/Arrow";
import Logo from "@Components/Icons/Logos/Logo";
import Table from "@Components/Table";
import { displayMonthData, displayRowKey } from "@Components/UsageTable";
import getBrokerName from "@Helpers/GetBrokerName";
import { displayCountry } from "@Shared/Helpers/Country";
import api from "@Api/index";
import Dropdown from "@Components/Form/Dropdown";
import MultiOptionsWithCheckbox from "@Components/Form/Dropdown/MultiOptionsWithCheckbox";
import { getTitleFormBillingEngine } from "@Helpers/Network";
import { CountryGroupType } from "@Shared/Entities/CountryGroups/CountryGroup/enums";
import styles from "./index.module.scss";
const totalRowTitle = "Total";
const networkRowtitle = "Network";
export default class UsageData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            arrows: {},
            checkedFields: {},
            networks: [],
            selectedNetwork: {},
            countryGroups: {},
            selectedCountryGroup: {},
        };
    }
    getAllNetworks = async () => {
        if (!this.props.showCountryGroups) {
            return;
        }
        return api
            .get("/country-groups?start=0&size=100")
            .then(({ data }) => data)
            .catch((error) => {
            throw error.response.data;
        });
    };
    getCountryGroupsByNetwork = async (networkId) => {
        if (!this.props.showCountryGroups) {
            return;
        }
        return api
            .get(`/country-groups/${networkId}?start=0&size=100`)
            .then(({ data }) => data)
            .catch((error) => {
            throw error.response.data;
        });
    };
    changeNetwork = async ({ option, tableKey, }) => {
        const countryGroups = await this.getCountryGroupsByNetwork(option.value);
        this.setState({
            selectedNetwork: {
                ...this.state.selectedNetwork,
                [tableKey]: option.value,
            },
            countryGroups: {
                ...this.state.countryGroups,
                [tableKey]: countryGroups?.items?.map((item) => item.item),
            },
            selectedCountryGroup: {
                ...this.state.selectedCountryGroup,
                [tableKey]: {},
            },
            checkedFields: {
                ...this.state.checkedFields,
                [tableKey]: {},
            },
        });
    };
    renderNetwork = (tableKey) => {
        return (React.createElement("div", null,
            React.createElement("h4", { className: styles.text }, "Tariff Plan Name"),
            React.createElement(Dropdown, { placeholder: "Select tariff plan name", options: this.state.networks.map((network) => ({
                    value: network.id,
                    label: network.name,
                })), value: this.state.selectedNetwork[tableKey], onChange: ({ option }) => this.changeNetwork({
                    option,
                    tableKey,
                }) })));
    };
    renderNetworkLabel = (tableKey) => {
        const label = this.state.networks.find((network) => network.id === this.state.selectedNetwork[tableKey])?.name;
        if (!label) {
            return null;
        }
        return React.createElement("p", { className: styles.labelText },
            label,
            ":");
    };
    handleCheckedFields = (countryBreakdown, selectedCountryOrigin, selectedCountryDestination) => {
        if (!selectedCountryOrigin[0] && !selectedCountryDestination[0]) {
            return {};
        }
        let filteredList = [];
        if (!selectedCountryOrigin[0]) {
            filteredList = countryBreakdown.filter((country) => {
                return selectedCountryDestination.some((selectedCountry) => displayCountry(selectedCountry) ===
                    displayCountry(country.destination));
            });
        }
        if (!selectedCountryDestination[0]) {
            filteredList = countryBreakdown.filter((country) => {
                return selectedCountryOrigin.some((selectedCountry) => displayCountry(selectedCountry) ===
                    displayCountry(country.key));
            });
        }
        if (selectedCountryOrigin[0] && selectedCountryDestination[0]) {
            filteredList = countryBreakdown.filter((country) => {
                return selectedCountryOrigin.some((selectedCountry) => {
                    return (displayCountry(selectedCountry) ===
                        displayCountry(country.key) &&
                        selectedCountryDestination.some((selectedCountry) => displayCountry(selectedCountry) ===
                            displayCountry(country.destination)));
                });
            });
        }
        return Object.fromEntries(filteredList.map((country) => [country.title, true]));
    };
    changeCountryGroup = ({ option, tableKey, countryBreakdown, type, }) => {
        const [first, last] = tableKey.split("_");
        const selectedCountries = this.state.countryGroups[first]
            .filter((group) => option.some((option) => option.value === group.id))
            .flatMap((group) => group.selectedCountries);
        let checkedFields = {};
        if (type) {
            const isOrigin = type === "origin";
            if (isOrigin) {
                const destinationOption = this.state.selectedCountryGroup[first]?.[`${last}_destination`] || [];
                const selectedCountryDestination = this.state.countryGroups[first]
                    .filter((group) => destinationOption.includes(group.id))
                    .flatMap((group) => group.selectedCountries);
                checkedFields = this.handleCheckedFields(countryBreakdown, selectedCountries, selectedCountryDestination);
            }
            else {
                const originOption = this.state.selectedCountryGroup[first]?.[`${last}_origin`] || [];
                const selectedCountryOrigin = this.state.countryGroups[first]
                    .filter((group) => originOption.includes(group.id))
                    .flatMap((group) => group.selectedCountries);
                checkedFields = this.handleCheckedFields(countryBreakdown, selectedCountryOrigin, selectedCountries);
            }
        }
        else {
            checkedFields = this.handleCheckedFields(countryBreakdown, selectedCountries, []);
        }
        this.setState({
            selectedCountryGroup: {
                ...this.state.selectedCountryGroup,
                [first]: {
                    ...this.state.selectedCountryGroup[first],
                    [`${last}${type ? `_${type}` : ""}`]: option.map((option) => option.value),
                },
            },
            checkedFields: {
                ...this.state.checkedFields,
                [first]: {
                    ...this.state.checkedFields[first],
                    [last]: checkedFields,
                },
            },
        });
    };
    getOptions = (key, groupType) => {
        const options = this.state.countryGroups[key]?.filter((group) => group.type === groupType) || [];
        return options.sort((a, b) => {
            const aCreatedAt = a.createdAt;
            const bCreatedAt = b.createdAt;
            return aCreatedAt.localeCompare(bCreatedAt);
        });
    };
    renderCountryGroups = (tableKey, countryBreakdown) => {
        const [first, last] = tableKey.split("_");
        const type = first === "IDD" ? CountryGroupType.IDD : CountryGroupType.Roaming;
        const options = this.getOptions(first, type);
        return (React.createElement("div", null,
            React.createElement("h4", { className: styles.text }, "Country Group"),
            React.createElement(MultiOptionsWithCheckbox, { placeholder: "Select country groups", options: options.map((group) => ({
                    value: group.id,
                    label: group.name,
                })), isMulti: true, hasCheckAll: true, labelCheckAll: "All Groups", isSearchable: false, value: this.state.selectedCountryGroup[first]?.[last] || [], onChange: ({ option }) => this.changeCountryGroup({
                    option,
                    tableKey,
                    countryBreakdown,
                }) })));
    };
    renderOriginDestinationCountryGroups = (tableKey, countryBreakdown) => {
        const [first, last] = tableKey.split("_");
        const type = first === "IDD" ? CountryGroupType.IDD : CountryGroupType.Roaming;
        const options = this.getOptions(first, type);
        return (React.createElement("div", { className: styles.originDestinationCountryGroups },
            React.createElement("div", { className: styles.countryGroup },
                React.createElement("h4", { className: styles.text }, "Origin Country Group"),
                React.createElement(MultiOptionsWithCheckbox, { placeholder: "Select country groups", options: options.map((group) => ({
                        value: group.id,
                        label: group.name,
                    })), isMulti: true, hasCheckAll: true, labelCheckAll: "All Groups", isSearchable: false, value: this.state.selectedCountryGroup[first]?.[`${last}_origin`] || [], onChange: ({ option }) => this.changeCountryGroup({
                        option,
                        tableKey,
                        countryBreakdown,
                        type: "origin",
                    }) })),
            React.createElement("div", { className: styles.countryGroup },
                React.createElement("h4", { className: styles.text }, "Destination Country Group"),
                React.createElement(MultiOptionsWithCheckbox, { placeholder: "Select country groups", options: options.map((group) => ({
                        value: group.id,
                        label: group.name,
                    })), isMulti: true, hasCheckAll: true, labelCheckAll: "All Groups", isSearchable: false, value: this.state.selectedCountryGroup[first]?.[`${last}_destination`] || [], onChange: ({ option }) => this.changeCountryGroup({
                        option,
                        tableKey,
                        countryBreakdown,
                        type: "destination",
                    }) }))));
    };
    getAverage = ({ arrow, countryBreakdown, avg, isSearchMatch, noArrow, popout, tableRowKey, title, checkbox, topRow, key, destination, className, ...months }) => {
        const monthsArray = Object.values(months);
        if (monthsArray.length === 0) {
            return 0;
        }
        const total = monthsArray.reduce((total, current) => {
            return total + Number(current);
        }, 0);
        return total / monthsArray.length;
    };
    showOpenedRows = (rows, tableKey) => {
        const { arrows = {} } = this.state;
        const table = arrows[tableKey] || {};
        Object.keys(table).map((rowKey) => {
            const row = table[rowKey];
            if (row) {
                const rowIndex = rows.findIndex(({ title }) => {
                    return title === rowKey;
                });
                const rowData = rows[rowIndex].countryBreakdown;
                rows.splice(rowIndex + 1, 0, ...rowData);
                const table = this.state.checkedFields[tableKey] || {};
                const countriesSelected = table[rowKey] || {};
                const totalSelected = Object.keys(countriesSelected)
                    .filter((key) => countriesSelected[key] === true)
                    .reduce((total, key) => {
                    const countryRow = rowData.find(({ title }) => title === key);
                    if (countryRow) {
                        const { title, topRow, ...countryData } = countryRow;
                        Object.keys(countryData).map((month) => {
                            total[month] =
                                (total[month] || 0) + countryData[month];
                        });
                    }
                    return total;
                }, {});
                rows.splice(rowIndex + 1, 0, {
                    title: totalRowTitle,
                    ...totalSelected,
                    topRow: rowKey,
                    className: styles.selectedRow,
                });
                const showFilterCountryGroup = (tableKey === "UK" && rowKey === "Non-UK Data") ||
                    ["Roaming", "IDD"].includes(tableKey);
                if (showFilterCountryGroup && this.props.showCountryGroups) {
                    rows.splice(rowIndex + 1, 0, {
                        title: networkRowtitle,
                        topRow: rowKey,
                        countryBreakdown: rowData,
                    });
                }
                if (tableKey === "UK" &&
                    !this.state.selectedNetwork[tableKey] &&
                    this.props.showCountryGroups) {
                    const networkData = this.state.networks.find((network) => network.name ===
                        getTitleFormBillingEngine(this.props.tariffData?.[0]?.networkComponent)) || this.state.networks[0];
                    this.changeNetwork({
                        option: {
                            value: networkData.id,
                            label: networkData.name,
                        },
                        tableKey: `${tableKey}`,
                    });
                }
            }
        });
    };
    showPopoutIcon = (object) => {
        const openPopout = () => {
            this.props.openPopout(object);
        };
        return (React.createElement(Logo, { className: `${styles.placeholder} ${styles.logo}`, onClick: openPopout }));
    };
    getTables = () => {
        const { breakdown: { stats, analysis }, } = this.props;
        if (!stats) {
            return React.createElement(React.Fragment, null);
        }
        const dataMonths = Object.keys(stats?.UK?.Data || {}).sort((a, b) => {
            return new Date(a).getTime() - new Date(b).getTime();
        });
        const fields = (tableTitle) => [
            {
                header: tableTitle,
                field: "title",
                leftAlign: true,
                display: (data) => {
                    return displayRowKey(data.title);
                },
                className: styles.titleColumn,
                widthControl: true,
            },
            {
                header: "",
                field: "arrow",
                leftAlign: true,
                widthControl: true,
                display: (data) => {
                    const topRow = data.topRow;
                    if (topRow !== undefined && data.title !== totalRowTitle) {
                        const countryName = data.title;
                        const changeCheckbox = () => {
                            const { checkedFields = {} } = this.state;
                            const table = checkedFields[tableTitle] || {};
                            const row = table[topRow] || {};
                            row[countryName] = !row[countryName];
                            table[topRow] = row;
                            checkedFields[tableTitle] = table;
                            this.setState({
                                checkedFields,
                            });
                        };
                        const table = this.state.checkedFields[tableTitle] || {};
                        const row = table[topRow] || {};
                        const shown = row[countryName];
                        return (React.createElement(Checkbox, { change: changeCheckbox, checked: shown }));
                    }
                    const title = tableTitle.replace(" ", "");
                    const { arrows = {} } = this.state;
                    const table = arrows[title] || {};
                    const shown = table[data.title];
                    const toggleArrow = () => {
                        table[data.title] = !shown;
                        arrows[title] = table;
                        this.setState({
                            arrows,
                        });
                    };
                    const showArrow = data.arrow;
                    if (showArrow) {
                        const dataExists = data.countryBreakdown !== undefined &&
                            data.countryBreakdown.length > 0;
                        if (dataExists) {
                            return (React.createElement(Arrow, { className: styles.arrow, onClick: toggleArrow, rotate: shown ? 90 : 0 }));
                        }
                    }
                },
            },
            ...[...dataMonths].map((month) => ({
                header: month,
                field: month,
                widthControl: true,
                alias: (data) => {
                    return displayMonthData(data[month], data.topRow || data.title);
                },
                rightAlign: true,
                hidden: this.props.tender?.isSmallBusiness,
                className: styles.monthData,
            })),
            {
                header: this.props.tender?.isSmallBusiness ? (React.createElement("div", { className: styles.avgHeader }, "Average monthly usage")) : ("Avg."),
                field: "avg",
                widthControl: true,
                alias: (data) => {
                    const avg = this.getAverage(data);
                    return displayMonthData(avg, data.topRow || data.title);
                },
                rightAlign: true,
                className: styles.monthData,
            },
            {
                header: "",
                field: "popout",
                display: (data) => {
                    const list = [
                        {
                            row: "Data",
                            table: "UK",
                            total: analysis.UK_Data?.total,
                        },
                        {
                            row: "Non-UK Data",
                            table: "UK",
                            total: analysis.Roaming_Data?.total,
                        },
                        {
                            row: "Prem. Calls",
                            table: "UK",
                            total: analysis.UK_Premium_Calls?.total,
                        },
                        {
                            row: "Biz. Rate Calls",
                            table: "UK",
                            total: analysis.UK_Business_Calls?.total,
                        },
                        {
                            row: "Prem. SMS",
                            table: "UK",
                            total: analysis.UK_Premium_SMS?.total,
                        },
                        {
                            row: "Prem. MMS",
                            table: "UK",
                            total: analysis.UK_Premium_MMS?.total,
                        },
                        {
                            row: "Call",
                            table: "IDD",
                            total: analysis.IDD_Calls?.total,
                        },
                        {
                            row: "SMS",
                            table: "IDD",
                            total: analysis.IDD_SMS?.total,
                        },
                        {
                            row: "MMS",
                            table: "IDD",
                            total: analysis.IDD_MMS?.total,
                        },
                        {
                            row: "Data",
                            table: "Roaming",
                            total: analysis.Roaming_Data?.total,
                        },
                        {
                            row: "Days",
                            table: "Roaming",
                            total: analysis.Roaming_Days?.total,
                        },
                        {
                            row: "Call",
                            table: "Roaming",
                            total: analysis.Roaming_Calls?.total,
                        },
                        {
                            row: "SMS",
                            table: "Roaming",
                            total: analysis.Roaming_SMS?.total,
                        },
                        {
                            row: "MMS",
                            table: "Roaming",
                            total: analysis.Roaming_MMS?.total,
                        },
                    ].filter(({ total }) => total > 0);
                    const object = list.find(({ row, table }) => {
                        return row === data.title && table === tableTitle;
                    });
                    if (object !== undefined) {
                        return this.showPopoutIcon(object);
                    }
                    return React.createElement("div", { className: styles.placeholder });
                },
            },
            {
                hidden: true,
                field: "topRow",
            },
            {
                hidden: true,
                field: "className",
            },
            {
                hidden: true,
                field: "countryBreakdown",
            },
        ];
        const createTable = (data, tableTitle) => {
            this.sortRows(data);
            this.showOpenedRows(data, tableTitle);
            const hasNetworkData = data.some(({ countryBreakdown }) => !!countryBreakdown?.[0]);
            if (!hasNetworkData || !this.props.showCountryGroups) {
                return (React.createElement(Table, { fields: fields(tableTitle), data: data, alternate: true, noNav: true, className: styles.table, noPadding: true, padding: "0.2rem" }));
            }
            let index = 0;
            const dataGroup = data.reduce((dataGroup, datum) => {
                if (datum.title === networkRowtitle) {
                    dataGroup[index + 1] = [datum];
                    index += 2;
                }
                else if (dataGroup[index]) {
                    dataGroup[index].push(datum);
                }
                else {
                    dataGroup[index] = [datum];
                }
                return dataGroup;
            }, []);
            const isUK = tableTitle === "UK";
            if (!isUK && !this.state.selectedNetwork[tableTitle]) {
                const networkData = this.state.networks.find((network) => network.name ===
                    getTitleFormBillingEngine(this.props.tariffData?.[0]?.networkComponent)) || this.state.networks[0];
                if (networkData) {
                    this.changeNetwork({
                        option: {
                            value: networkData.id,
                            label: networkData.name,
                        },
                        tableKey: `${tableTitle}`,
                    });
                }
            }
            return (React.createElement(React.Fragment, null,
                !isUK && (React.createElement(React.Fragment, null,
                    React.createElement(Table, { fields: fields(tableTitle), data: [], alternate: true, noNav: true, className: styles.table, noPadding: true, padding: "0.2rem" }),
                    this.renderNetwork(`${tableTitle}`))),
                dataGroup.map((group, index) => {
                    const networkData = group[0].title === networkRowtitle;
                    if (networkData && this.props.showCountryGroups) {
                        const hasOriginDestination = group.some(({ countryBreakdown }) => !!countryBreakdown?.[0]?.title.includes("to"));
                        return (React.createElement("div", { key: `${group[0].title}_${index}`, className: styles.networkRow },
                            isUK
                                ? this.renderNetwork(`${tableTitle}`)
                                : this.renderNetworkLabel(`${tableTitle}`),
                            hasOriginDestination
                                ? this.renderOriginDestinationCountryGroups(`${tableTitle}_${group[0].topRow}`, group[0].countryBreakdown)
                                : this.renderCountryGroups(`${tableTitle}_${group[0].topRow}`, group[0].countryBreakdown)));
                    }
                    return (React.createElement(Table, { key: group[0].title, fields: fields(tableTitle), data: group, alternate: true, noNav: true, noHeader: !isUK, className: styles.table, noPadding: true, padding: "0.2rem" }));
                })));
        };
        const ukData = Object.keys(stats.UK).map((title) => {
            const shortenTitle = () => {
                const premium = /premium/i;
                if (premium.test(title)) {
                    return title.replace(premium, "Prem.");
                }
                const standard = /standard/i;
                if (standard.test(title)) {
                    return title.replace(standard, "Std.");
                }
                const directory = /directory calls/i;
                if (directory.test(title)) {
                    return title.replace(directory, "Dir. Enquiries");
                }
                const business = /business/i;
                if (business.test(title)) {
                    return title.replace(business, "Biz.");
                }
                return title;
            };
            const shortenedTitle = shortenTitle();
            return {
                title: shortenedTitle,
                ...stats.UK[title],
            };
        });
        const getRoamingCountryBreakdown = (title, topRow) => {
            const countryStats = stats.Roaming[title]?.origin || {};
            const countryBreakdown = Object.keys(countryStats).map((origin) => {
                return Object.keys(countryStats[origin]).map((destination) => {
                    const countryTitle = title === "Data" || title === "Days"
                        ? displayCountry(origin, this.props.tender?.isSmallBusiness)
                        : `${displayCountry(origin, this.props.tender?.isSmallBusiness)} to ${displayCountry(destination, this.props.tender?.isSmallBusiness)}`;
                    return {
                        title: countryTitle,
                        topRow,
                        key: origin,
                        destination,
                        ...countryStats[origin][destination],
                    };
                });
            });
            return countryBreakdown.flat();
        };
        const showOutOfUKUsage = !this.props.tender?.isSmallBusiness ||
            this.props.tender?.details.iddCost;
        if (showOutOfUKUsage) {
            ukData.push({
                title: "Non-UK Data",
                arrow: true,
                countryBreakdown: getRoamingCountryBreakdown("Data", "Non-UK Data"),
                ...stats.Roaming?.Data?.total,
            });
        }
        const iddData = Object.keys(stats.IDD).map((title) => {
            const countryStats = stats.IDD[title].destination || {};
            const countryBreakdown = Object.keys(countryStats).map((country) => {
                return {
                    title: displayCountry(country, this.props.tender?.isSmallBusiness),
                    topRow: title,
                    key: country,
                    ...countryStats[country],
                };
            });
            return {
                title,
                ...stats.IDD[title].total,
                arrow: true,
                countryBreakdown,
            };
        });
        const roamingData = Object.keys(stats.Roaming).map((title) => {
            if (title === "Days") {
                const total = {};
                Object.keys(stats.Roaming[title]).map((country) => {
                    Object.keys(stats.Roaming[title][country]).map((month) => {
                        const current = total[month] || 0;
                        total[month] =
                            current +
                                stats.Roaming[title][country][month];
                        return total;
                    });
                });
                const countryBreakdown = Object.keys(stats.Roaming[title]).map((country) => {
                    return {
                        title: displayCountry(country, this.props.tender?.isSmallBusiness),
                        topRow: title,
                        key: country,
                        ...stats.Roaming[title][country],
                    };
                });
                return {
                    title,
                    ...total,
                    arrow: true,
                    countryBreakdown,
                };
            }
            return {
                title,
                ...stats.Roaming[title].total,
                arrow: true,
                countryBreakdown: getRoamingCountryBreakdown(title, title),
            };
        });
        const ukTable = createTable(ukData, "UK");
        const iddTable = showOutOfUKUsage ? createTable(iddData, "IDD") : React.createElement(React.Fragment, null);
        const roamingTable = showOutOfUKUsage ? (createTable(roamingData, "Roaming")) : (React.createElement(React.Fragment, null));
        return (React.createElement(React.Fragment, null,
            ukTable,
            iddTable,
            roamingTable));
    };
    sortRows = (data) => {
        const typeScore = (title) => {
            if (/data/i.test(title)) {
                return 4;
            }
            if (/call/i.test(title)) {
                return 3;
            }
            if (/sms/i.test(title)) {
                return 2;
            }
            if (/mms/i.test(title)) {
                return 1;
            }
            return 0;
        };
        return data.sort((a, b) => {
            const t = typeScore(b.title) - typeScore(a.title);
            return t === 0 ? a.title.length - b.title.length : t;
        });
    };
    displayTextBox = () => {
        if (this.props.tender?.isSmallBusiness) {
            return (React.createElement("div", { className: styles.explanationBox },
                React.createElement("div", { className: styles.text },
                    "The customer has not provided their Current Contract's Bill Reports. This table shows an ",
                    React.createElement("b", null, "average"),
                    " of the Usage that other similar Customers on Predict have\u00A0had.")));
        }
        const superUsers = this.props.breakdown.superUsers.length;
        return (React.createElement("div", { className: styles.explanationBox },
            React.createElement("div", { className: styles.text },
                "Click on any of the ",
                getBrokerName(),
                " logos to view a more thorough analysis of the customer's usage data",
                superUsers > 0 && (React.createElement("div", null,
                    React.createElement("span", { className: styles.superUsers },
                        "There are ",
                        superUsers,
                        " super users"),
                    this.showPopoutIcon({
                        table: "Super Users",
                    })))),
            React.createElement(Logo, { className: styles.explanationLogo })));
    };
    componentDidMount() {
        this.getAllNetworks()
            .then((data) => {
            this.setState({
                networks: data?.items || [],
            });
        })
            .catch((error) => {
            console.error("Failed to fetch country groups:", error);
        });
    }
    render() {
        if (this.props.isClosed) {
            return React.createElement(React.Fragment, null);
        }
        const tables = this.getTables();
        return (React.createElement(React.Fragment, null,
            this.displayTextBox(),
            tables));
    }
}
